import Fraction from './fractionClass';
export default class Surd {
    constructor(coeff, surd) {
        this.coeff = coeff;
        this.surd = surd;
        this.simplify();
    }
    simplify() {
        let primes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29];
        let surdNum;
        let surdDen = 1;
        primes.forEach(prime => {
            if (typeof this.surd === "number") {
                surdNum = this.surd;
            }
            else {
                this.surd.simplify();
                surdNum = this.surd.num;
                surdDen = this.surd.den;
            }
            if (surdNum % (prime * prime) == 0) {
                if (typeof this.coeff === "number") {
                    this.coeff *= prime;
                }
                else {
                    this.coeff = this.coeff.multiply(prime);
                }
                if (typeof this.surd === "number") {
                    this.surd /= (prime * prime);
                }
                else {
                    this.surd = this.surd.divide(prime * prime);
                }
                this.simplify();
            }
            if (surdDen % (prime * prime) == 0) {
                if (typeof this.coeff === "number") {
                    let newCoeff = new Fraction(this.coeff, 1);
                    this.coeff = newCoeff.divide(prime);
                }
                else {
                    this.coeff = this.coeff.divide(prime);
                }
                if (typeof this.surd !== "number") {
                    this.surd = this.surd.multiply(prime * prime);
                }
                this.simplify();
            }
        });
    }
    toString() {
        this.simplify();
        let coeffString = "", surdString = "";
        if (typeof this.surd === "number") {
            if (this.surd != 1) {
                surdString = "\\sqrt{" + this.surd.toString() + "}";
            }
        }
        else {
            if (!(this.surd.num == 1 && this.surd.den == 1)) {
                surdString = "\\sqrt{" + this.surd.toString() + "}";
            }
        }
        if (typeof this.coeff === "number") {
            if (surdString) {
                if (this.coeff != 1) {
                    coeffString = this.coeff.toString();
                }
            }
            else {
                coeffString = this.coeff.toString();
            }
        }
        else {
            if (surdString) {
                if (!(this.coeff.num == 1 && this.coeff.den == 1)) {
                    coeffString = this.coeff.toString();
                }
            }
            else {
                coeffString = this.coeff.toString();
            }
        }
        return coeffString + surdString;
    }
}
